__turbopack_context__.v({
  "message": "confirm-dialog-module__Cdad7W__message",
  "panel": "confirm-dialog-module__Cdad7W__panel",
  "title": "confirm-dialog-module__Cdad7W__title",
});
